import { cn } from "../../lib/cn";

interface DialogFooterProps {
  children: React.ReactNode;
  className?: string;
}

function DialogFooter({ children, className }: DialogFooterProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-between px-7 pb-7 pt-6",
        className,
      )}
    >
      {children}
    </div>
  );
}

export { DialogFooter };
